import {
  Input as AntdInput,
  InputProps as AntdInputProps,
  InputRef,
} from 'antd';
import type {
  TextAreaProps as AntdTextAreaProps,
  TextAreaRef,
} from 'antd/es/input/TextArea';
import { forwardRef } from 'react';

export interface InputProps extends AntdInputProps {
  'data-cy'?: string;
}

export interface PasswordProps extends AntdInputProps {
  'data-cy'?: string;
}

export interface TextAreaProps extends AntdTextAreaProps {
  'data-cy'?: string;
}

const Input = forwardRef<InputRef, InputProps>((props, ref) => {
  return <AntdInput data-cy={props['data-cy']} ref={ref} {...props} />;
});

Input.displayName = 'Input';

const Password = forwardRef<InputRef, PasswordProps>((props, ref) => {
  return <AntdInput.Password data-cy={props['data-cy']} ref={ref} {...props} />;
});

Password.displayName = 'Password';

const TextArea = forwardRef<TextAreaRef, TextAreaProps>(
  ({ rows = 4, ...rest }, ref) => {
    return (
      <AntdInput.TextArea
        data-cy={rest['data-cy']}
        ref={ref}
        rows={rows}
        {...rest}
      />
    );
  }
);

TextArea.displayName = 'TextArea';

export { Password, TextArea, Input };
